import React from 'react'
import { RegistersFilters, TotalRegisters } from './style'

export default function Quantity ({ links }) {
  return (
    <RegistersFilters>
      {links ?
        <TotalRegisters>
          Total de registros
          <span>{links}</span>
        </TotalRegisters>
      : ''}
    </RegistersFilters>
  );
}
